import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 获取首页数据
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function getHomePageData(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/system.initPlatformData',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取用户信息
 * @returns {Promise} Promise对象
 */
export function getUserInfo() {
  return new Promise((resolve, reject) => {
    request({
      url: '/user.getUserInfo',
      method: 'get'
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存访问日志
 * @param {Object} data 请求数据
 * @returns {Promise} Promise对象
 */
export function saveAccessLog(data) {
  return new Promise((resolve, reject) => {
    request({
      url: 'websiteAccessLog.saveWebsiteAccessLog',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}